/**
 * Studio → Prompts (index) — list view at exact `/studio/prompts/`.
 *
 * Thin wrapper that mounts the shared `<PromptEditor scope="tenant" />`.
 * All prompts authoring logic lives in
 * `@/components/prompt-editor-shared/PromptEditor.tsx` — this file's
 * job is just the TanStack file-route binding so the framework picks
 * up the route at /studio/prompts/.
 *
 * The detail page at /studio/prompts/:promptId is the canonical full
 * edit surface; the Sheet in `<PromptEditor>` remains for quick create
 * + quick edit.
 */
import { createFileRoute } from '@tanstack/react-router';
import { PromptEditor } from '@/components/prompt-editor-shared/PromptEditor';

export const Route = createFileRoute('/studio/prompts/')({
  component: StudioPromptsIndexPage,
});

function StudioPromptsIndexPage() {
  return <PromptEditor scope="tenant" />;
}
